export default (theme) => ({
  authorizationWelcomeText: {
    marginTop: 20,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  title: {
    position: 'relative',
    zIndex: 1000,
    fontSize: 88,
    fontWeight: 'bold',
    [theme.breakpoints.down('xl')]: {
      fontSize: 72,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 24,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 22,
    },
  },
  subtitle: {
    width: 400,
    fontSize: 57,
    lineHeight: 0.9,
    fontWeight: 'bold',
    position: 'relative',
    zIndex: 1000,
    [theme.breakpoints.down('xl')]: {
      fontSize: 42,
      width: 320,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 19,
      width: 'auto',
      textAlign: 'center',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
});
